import { createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "page-wr"
}
const _hoisted_2 = {
  key: 0,
  class: "card"
}
const _hoisted_3 = { class: "default-form" }
const _hoisted_4 = { class: "input-row" }
const _hoisted_5 = {
  key: 0,
  class: "input-wr"
}
const _hoisted_6 = {
  key: 0,
  class: "error-hint"
}
const _hoisted_7 = {
  key: 1,
  class: "input-wr"
}
const _hoisted_8 = {
  key: 0,
  class: "error-hint"
}
const _hoisted_9 = { class: "input-row" }
const _hoisted_10 = {
  key: 0,
  class: "input-wr"
}
const _hoisted_11 = {
  key: 0,
  class: "error-hint"
}
const _hoisted_12 = {
  key: 1,
  class: "input-wr"
}
const _hoisted_13 = {
  key: 0,
  class: "error-hint"
}
const _hoisted_14 = { class: "input-row" }
const _hoisted_15 = {
  key: 0,
  class: "input-wr"
}
const _hoisted_16 = {
  key: 0,
  class: "error-hint"
}
const _hoisted_17 = {
  key: 1,
  class: "input-wr"
}
const _hoisted_18 = {
  key: 0,
  class: "error-hint"
}
const _hoisted_19 = {
  key: 0,
  class: "input-row"
}
const _hoisted_20 = ["value"]
const _hoisted_21 = { class: "buttons" }
const _hoisted_22 = {
  key: 1,
  class: "spinner"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (!$setup.loading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _cache[14] || (_cache[14] = _createElementVNode("h2", { class: "title-main" }, "Edit Details", -1)),
        ($setup.user)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("form", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  ($setup.isLandownerRole)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        _cache[6] || (_cache[6] = _createElementVNode("label", { class: "label" }, "Company Name", -1)),
                        _withDirectives(_createElementVNode("input", {
                          class: _normalizeClass(["input", { error: $setup.v$.detailsForm.companyName.$error }]),
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.detailsForm.companyName) = $event)),
                          type: "text",
                          placeholder: "Company Name"
                        }, null, 2), [
                          [_vModelText, $setup.detailsForm.companyName]
                        ]),
                        ($setup.v$.detailsForm.companyName.$error)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString($setup.v$.detailsForm.companyName.$errors[0].$message), 1))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  ($setup.isLandownerRole || $setup.isSalesPersonRole)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        _cache[7] || (_cache[7] = _createElementVNode("label", { class: "label" }, "First Name", -1)),
                        _withDirectives(_createElementVNode("input", {
                          class: _normalizeClass(["input", { error: $setup.v$.userForm.firstName.$error }]),
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.userForm.firstName) = $event)),
                          type: "text",
                          placeholder: "First Name"
                        }, null, 2), [
                          [_vModelText, $setup.userForm.firstName]
                        ]),
                        ($setup.v$.userForm.firstName.$error)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString($setup.v$.userForm.firstName.$errors[0].$message), 1))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_9, [
                  ($setup.isLandownerRole)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        _cache[8] || (_cache[8] = _createElementVNode("label", { class: "label" }, "Address", -1)),
                        _withDirectives(_createElementVNode("input", {
                          class: _normalizeClass(["input", { error: $setup.v$.detailsForm.companyAddress.$error }]),
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.detailsForm.companyAddress) = $event)),
                          type: "text",
                          placeholder: "Address"
                        }, null, 2), [
                          [_vModelText, $setup.detailsForm.companyAddress]
                        ]),
                        ($setup.v$.detailsForm.companyAddress.$error)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString($setup.v$.detailsForm.companyAddress.$errors[0].$message), 1))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  ($setup.isLandownerRole || $setup.isSalesPersonRole)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                        _cache[9] || (_cache[9] = _createElementVNode("label", { class: "label" }, "Last Name", -1)),
                        _withDirectives(_createElementVNode("input", {
                          class: _normalizeClass(["input", { error: $setup.v$.userForm.lastName.$error }]),
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.userForm.lastName) = $event)),
                          type: "text",
                          placeholder: "Last Name"
                        }, null, 2), [
                          [_vModelText, $setup.userForm.lastName]
                        ]),
                        ($setup.v$.userForm.lastName.$error)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString($setup.v$.userForm.lastName.$errors[0].$message), 1))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_14, [
                  ($setup.isLandownerRole)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                        _cache[10] || (_cache[10] = _createElementVNode("label", { class: "label" }, "ABN / ACN", -1)),
                        _withDirectives(_createElementVNode("input", {
                          class: _normalizeClass(["input", { error: $setup.v$.detailsForm.abnAcn.$error }]),
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.detailsForm.abnAcn) = $event)),
                          type: "text",
                          placeholder: "ABN / ACN"
                        }, null, 2), [
                          [_vModelText, $setup.detailsForm.abnAcn]
                        ]),
                        ($setup.v$.detailsForm.abnAcn.$error)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString($setup.v$.detailsForm.abnAcn.$errors[0].$message), 1))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  ($setup.isLandownerRole || $setup.isSalesPersonRole)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                        _cache[11] || (_cache[11] = _createElementVNode("label", { class: "label" }, "Phone", -1)),
                        _createVNode($setup["Cleave"], {
                          class: _normalizeClass(["input", { error: $setup.v$.userForm.phone.$error }]),
                          modelValue: $setup.userForm.phone,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.userForm.phone) = $event)),
                          options: $setup.phoneNumberOption($setup.userForm.phone),
                          type: "text",
                          placeholder: "0412 345 678"
                        }, null, 8, ["modelValue", "options", "class"]),
                        ($setup.v$.userForm.phone.$error)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_18, "Invalid phone"))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                ($setup.isLandownerRole || $setup.isSalesPersonRole)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["input-wr", { right: $setup.isLandownerRole }])
                      }, [
                        _cache[12] || (_cache[12] = _createElementVNode("label", { class: "label" }, "Email", -1)),
                        _createElementVNode("input", {
                          class: "input",
                          value: $setup.user.email,
                          type: "email",
                          readonly: "",
                          placeholder: "Email"
                        }, null, 8, _hoisted_20)
                      ], 2)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("button", {
                  class: "button default primary v2",
                  onClick: $setup.updateUser
                }, "Save Changes"),
                _createVNode(_component_router_link, {
                  class: "button default cancel",
                  to: { name: 'ProfileGeneralV2' }
                }, {
                  default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                    _createTextVNode("Cancel", -1)
                  ]))]),
                  _: 1
                })
              ])
            ]))
          : _createCommentVNode("", true)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_22))
}